exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pricing-options{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}@media screen and (min-width:480px){.pricing-options{-ms-flex-wrap:nowrap;flex-wrap:nowrap}}.pricing-option{-ms-flex-preferred-size:100%;flex-basis:100%;text-align:center}@media screen and (min-width:480px){.pricing-option{-ms-flex-preferred-size:33.334%;flex-basis:33.334%}}.pricing-options-footnotes>p:first-child{margin-top:10px}.pricing-options-footnotes a{padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/stylus-loader!./src/components/pricingoptions/pricingoptions.styl
// module id = 509
// module chunks = 0